// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3zvl4","label":"Completed_label__1IxuO"};